﻿import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';

export function render() {
  var splide = new Splide('.splide', {
    perPage: 2.5,
    focus: 0,
    omitEnd: true,
    drag: 'free',
    breakpoints: {
      640: {
        perPage: 1.2,
      },
      720: {
        perPage: 1.6,
      },
      1080: {
        perPage: 2.2,
      },
    },
  });
  splide.mount();
}
